/**
 * AB Test Service
 * Client-side service for AB test API interactions
 */

import apiService from './api.service'

const abTestService = {
  /**
   * Get authenticated user's active AB test assignments with content
   * @param {Number} languageid - Language ID
   * @returns {Promise<{ assignments: Array }>}
   */
  getMyAssignments: (languageid) =>
    apiService.get(`/api/abtest/me?languageid=${languageid}`),

  /**
   * Log a popup impression event
   * @param {{ test_id: Number, popup_id: String }} params
   */
  logPopupImpression: (params) =>
    apiService.post('/api/abtest/popup-impression', params),

  /**
   * Log a popup CTA action click
   * @param {{ test_id: Number, popup_id: String, action: String }} params
   * action: 'View Tour' | 'Maybe Later' | 'Do Not Show'
   */
  logPopupAction: (params) =>
    apiService.post('/api/abtest/popup-action', params),

  /**
   * Log guided tour completion
   * @param {{ test_id: Number, time_spent_seconds: Number }} params
   */
  logTourComplete: (params) =>
    apiService.post('/api/abtest/tour-complete', params),
}

export default abTestService
